import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  display:${({ visibility }) => visibility ? ' ' : 'none'};
  width: 100%;
  height: 100%;
  overflow:hidden;
  .alr-ms{
    margin-top: 1rem;
  }
`;
export const SelectTags = styled.div`
  padding: 0 0.5rem;
  .tag--{
    border: solid 1px #1D86FF;
    color: #1D86FF;
  }
  .xtr{
    width: 100%;
  }
  .selected{
    color: #ffffff;
    background-color: #1D86FF;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
  span{
    white-space: nowrap;
  }
`;
export const Content = styled.div`
  width: 100%;
  max-height: calc(100% - 3.5rem);
  overflow-x: hidden;
  overflow-y: scroll;
  padding-bottom: 2rem;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
`;
